export const ADD_MAIN_HOME = "ADD_MAIN_HOME";
export const REMOVE_MAIN_HOME = "REMOVE_MAIN_HOME";